export default "__VITE_ASSET__DiGWeDDL__ 1920w";